import type { FC } from "react";
import React from "react";
import { CircularProgress } from "@arenko-group/arenko-ui";
import classNames from "classnames";
import css from "./Loader.module.css";

type LoaderProps = {
  loading?: boolean;
};

const Loader: FC<LoaderProps> = ({ loading }) => {
  return (
    <div className={css.loaderOuter}>
      <div
        aria-busy={loading ? "true" : "false"}
        aria-valuetext="loading"
        className={classNames(css.loaderOverlay, {
          [css.loading]: loading,
        })}
      >
        {loading && <CircularProgress />}
      </div>
    </div>
  );
};

export default Loader;
